(function() {
  'use strict';

  if (window.__honbayProductCardInitialized) return;
  window.__honbayProductCardInitialized = true;

  function initProductCardSwipers() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initProductCardSwipers, 100);
      return;
    }
    if (window.innerWidth > 767) return;

    const swiperContainers = document.querySelectorAll('.product-card__mobile-swiper:not([data-swiper-initialized])');
    swiperContainers.forEach(function(container) {
      container.setAttribute('data-swiper-initialized', 'true');
      const paginationEl = container.querySelector('.product-card__swiper-pagination');
      new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        allowTouchMove: true,
        touchEventsTarget: 'container',
        pagination: { el: paginationEl, clickable: true, type: 'bullets' },
        simulateTouch: true,
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: false,
        on: {
          touchStart: function(swiper, event) {
            if (event && event.touches && event.touches.length > 0) {
              swiper.touchStartX = event.touches[0].clientX;
              swiper.touchStartY = event.touches[0].clientY;
            } else if (event && event.clientX !== undefined) {
              swiper.touchStartX = event.clientX;
              swiper.touchStartY = event.clientY;
            }
          },
          touchMove: function(swiper, event) {
            if (swiper.touchStartX !== undefined) {
              let currentX, currentY;
              if (event && event.touches && event.touches.length > 0) {
                currentX = event.touches[0].clientX;
                currentY = event.touches[0].clientY;
              } else if (event && event.clientX !== undefined) {
                currentX = event.clientX;
                currentY = event.clientY;
              } else { return; }
              const diffX = Math.abs(currentX - swiper.touchStartX);
              const diffY = Math.abs(currentY - swiper.touchStartY);
              if (diffX > 10 || diffY > 10) {
                container.querySelectorAll('a').forEach(function(l){ l.style.pointerEvents = 'none'; });
              }
            }
          },
          touchEnd: function(swiper) {
            setTimeout(function() {
              container.querySelectorAll('a').forEach(function(l){ l.style.pointerEvents = ''; });
            }, 100);
            swiper.touchStartX = undefined;
            swiper.touchStartY = undefined;
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initProductCardSwipers, 500); });
  } else {
    setTimeout(initProductCardSwipers, 500);
  }

  const observer = new MutationObserver(function(mutations) {
    let shouldInit = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList?.contains('product-card__mobile-swiper') || node.querySelector?.('.product-card__mobile-swiper'))) {
            shouldInit = true;
          }
        });
      }
    });
    if (shouldInit) setTimeout(initProductCardSwipers, 100);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth <= 767) initProductCardSwipers();
    }, 250);
  });

  function enhanceProductCardForMobile() {
    function setupProductCardObserver(productCard) {
      const mobileSwiper = productCard.querySelector('.product-card__mobile-swiper');
      if (!mobileSwiper || window.innerWidth > 767) return;
      const swiperInstance = mobileSwiper.swiper;
      if (!swiperInstance) return;
      const primaryImage = productCard.querySelector('.product-card__image--primary');
      if (!primaryImage) return;
      let lastImageSrc = primaryImage.src;
      const imageObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            setTimeout(function() {
              const currentImage = productCard.querySelector('.product-card__image--primary');
              if (!currentImage) return;
              const newImageSrc = currentImage.src;
              if (newImageSrc === lastImageSrc) return;
              lastImageSrc = newImageSrc;
              const slide = currentImage.closest('.swiper-slide');
              if (slide && swiperInstance && swiperInstance.slides) {
                const slideIndex = Array.from(slide.parentElement.children).indexOf(slide);
                if (slideIndex >= 0 && slideIndex < swiperInstance.slides.length) {
                  try { swiperInstance.slideTo(slideIndex, 300); return; } catch(e){}
                }
              }
              if (swiperInstance && swiperInstance.slides) {
                for (let i = 0; i < swiperInstance.slides.length; i++) {
                  const slideImg = swiperInstance.slides[i].querySelector('img');
                  if (slideImg && slideImg.src === newImageSrc) {
                    try { swiperInstance.slideTo(i, 300); return; } catch(e){}
                  }
                }
              }
            }, 100);
          }
        });
      });
      imageObserver.observe(primaryImage, { attributes: true, attributeFilter: ['src'], childList: false, subtree: false });
      if (primaryImage.parentElement) {
        imageObserver.observe(primaryImage.parentElement, { childList: true, subtree: false });
      }
    }

    function setupAllProductCards() {
      document.querySelectorAll('product-card').forEach(function(productCard) {
        const mobileSwiper = productCard.querySelector('.product-card__mobile-swiper');
        if (mobileSwiper && !productCard.dataset.mobileObserverSetup) {
          productCard.dataset.mobileObserverSetup = 'true';
          setTimeout(function() { setupProductCardObserver(productCard); }, 100);
        }
      });
    }
    setupAllProductCards();

    const cardObserver = new MutationObserver(function(mutations) {
      let shouldSetup = false;
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.tagName === 'PRODUCT-CARD' || node.querySelector?.('product-card'))) shouldSetup = true;
        });
      });
      if (shouldSetup) setTimeout(setupAllProductCards, 100);
    });
    cardObserver.observe(document.body, { childList: true, subtree: true });
  }

  const productCache = {};

  document.addEventListener('change', async function(event) {
    const target = event.target;
    if (!target || target.type !== 'radio') return;
    const productCard = target.closest('product-card');
    if (!productCard || window.innerWidth > 767) return;
    const mobileSwiper = productCard.querySelector('.product-card__mobile-swiper');
    const swiperInstance = mobileSwiper?.swiper;
    if (!swiperInstance) return;
    const optionPosition = target.closest('[data-option-position]')?.getAttribute('data-option-position');
    if (!optionPosition) return;
    const optionValue = target.value;

    async function loadProductData(handle) {
      if (productCache[handle]) return productCache[handle];
      try {
        const url = (window.Shopify?.routes?.root || '/') + 'products/' + handle + '.js';
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) return null;
        const data = await res.json();
        productCache[handle] = data;
        return data;
      } catch(e) { return null; }
    }

    try {
      const productHandle = productCard.getAttribute('handle');
      if (!productHandle) return;
      let product = null;
      if (typeof ProductLoader !== 'undefined' && typeof ProductLoader.load === 'function') {
        try { product = await ProductLoader.load(productHandle); if (product) productCache[productHandle] = product; } catch(e) { product = null; }
      }
      if (!product) product = await loadProductData(productHandle);
      if (!product) return;

      const matchingVariant = product.variants.find(function(v) { return v['option' + optionPosition] === optionValue; });
      const featured = matchingVariant?.featured_media;
      if (!featured) return;

      const valueLower = (optionValue || '').toString().toLowerCase();
      let candidateMedia = [];
      try {
        candidateMedia = (product.media || []).filter(function(m) { return (m.alt || '').toString().toLowerCase().includes(valueLower); });
      } catch(e) { candidateMedia = []; }
      if (!candidateMedia || candidateMedia.length === 0) {
        const others = (product.media || []).filter(function(m) { return m.id !== featured.id; });
        candidateMedia = [featured].concat(others);
      } else {
        const withoutFeatured = candidateMedia.filter(function(m) { return m.id !== featured.id; });
        candidateMedia = [featured].concat(withoutFeatured);
      }

      const existingSlides = Array.from(mobileSwiper.querySelectorAll('.swiper-slide'));
      const exampleImg = existingSlides[0]?.querySelector('img');
      const baseClass = exampleImg?.className?.replace('product-card__image--primary', 'product-card__image') || 'product-card__image';
      const sizesAttr = exampleImg?.sizes || '';

      try {
        if (swiperInstance.removeAllSlides) swiperInstance.removeAllSlides();
        else mobileSwiper.querySelector('.swiper-wrapper').innerHTML = '';
      } catch(e) { mobileSwiper.querySelector('.swiper-wrapper').innerHTML = ''; }

      const wrapper = mobileSwiper.querySelector('.swiper-wrapper');
      const productUrl = product.url || (productCard.querySelector('a[href]')?.getAttribute('href')) || '#';

      candidateMedia.forEach(function(media, idx) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.setAttribute('data-media-id', media.id);
        const link = document.createElement('a');
        link.setAttribute('href', productUrl);
        link.setAttribute('data-instant', '');
        const img = new Image(media.preview_image?.width || 0, media.preview_image?.height || 0);
        img.className = (idx === 0 ? (baseClass + ' product-card__image--primary') : baseClass).trim();
        img.alt = media.alt || '';
        if (sizesAttr) img.sizes = sizesAttr;
        img.loading = idx === 0 ? 'eager' : 'lazy';
        if (media.preview_image && typeof generateSrcset === 'function') {
          img.srcset = generateSrcset(media.preview_image, [200,300,400,500,600,700,800,1000,1200,1400,1600,1800]);
          img.src = media.preview_image.src;
        } else {
          img.src = media.src || media.preview_image?.src || '';
        }
        link.appendChild(img);
        slide.appendChild(link);
        wrapper.appendChild(slide);
      });

      try { swiperInstance.update?.(); swiperInstance.slideTo?.(0, 0); } catch(e){}
    } catch(err) { console.warn('Variant change handling error (mobile):', err); }
  }, true);

  function waitForSwiperInit() {
    if (typeof Swiper === 'undefined') { setTimeout(waitForSwiperInit, 100); return; }
    setTimeout(function() { enhanceProductCardForMobile(); }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSwiperInit);
  } else {
    waitForSwiperInit();
  }
})();
